import {useClient, useDictionary} from '@adamlip/okeoke.client';
import useBasket from 'hooks/useBasket';
import useStorage from 'hooks/useStorage';
import {useEffect, useContext, useState} from 'react';
import {AppParamsContext} from 'contexts/AppParamsContext';
import Agents from './Agents';
import AgentParams from './AgentParams';
import {Card, CardBody, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader} from '@heroui/react';
import BarSoftButton from 'components/_NewComponents/BarSoftButton';
import FormattedNumber from 'components/FormattedNumber';
import Icon from 'assets/icons';
import PayIllustration from 'assets/icons/PayIllustration';
import {Banknote, Gem, WalletCards} from 'lucide-react';

export default function PaymentAgentSelector({paymentAgents, selectedID, selectPaymentAgent, usableMoney, setPayByVipMoney, paymentModalOpen, setPaymentModalOpen, paymentsNeeded}) {
	const {getValue} = useDictionary();
	const {getName} = useClient();
	const {appParams} = useContext(AppParamsContext);
	const {handleChangePaymentType, paymentType} = useBasket();
	const {getSV} = useStorage();
	const [offlineVisible, setOfflineVisible] = useState();
	const [selectedLocalAgentLabel, setSelectedLocalAgentLabel] = useState(null);
	const handleSelect = (agent) => {
		if (agent == null) return;
		if (agent === 'offline') {
			selectPaymentAgent(null);
			if (typeof setPayByVipMoney === 'function') setPayByVipMoney(false);
			handleChangePaymentType('Offline');
			setSelectedLocalAgentLabel(getValue(`app_v2_paymentTypes_Offline`));
			setPaymentModalOpen(false);
		}
		if (agent === 'vipMoney') {
			if (typeof setPayByVipMoney === 'function') setPayByVipMoney(true);
			selectPaymentAgent(null);
			setSelectedLocalAgentLabel(getValue(`app_v2_paymentTypes_vipMoney`));
			setPaymentModalOpen(false);
		}
		if (agent !== 'offline' && agent !== 'vipMoney') {
			let agentData = paymentAgents.find((a) => a.paymentAgentID === agent);
			selectPaymentAgent(agentData);
			setSelectedLocalAgentLabel(getName(agentData.name));
			setPaymentModalOpen(false);
		}
	};

	useEffect(() => {
		if (appParams?.basketModal?.offlinePayment == null) {
			setOfflineVisible(appParams?.basketModal?.paymentTypes?.offline);
		} else {
			setOfflineVisible(appParams?.basketModal?.offlinePayment);
		}
	}, [appParams]);

	useEffect(() => {
		if (typeof setPayByVipMoney === 'function') {
			if (selectedID) setPayByVipMoney(false);
		}
		//eslint-disable-next-line
	}, [selectedID]);

	useEffect(() => {
		if (!offlineVisible && paymentAgents != null && paymentAgents?.filter((agent) => agent.agentType === 'online').length === 1) {
			let theOne = paymentAgents?.filter((agent) => agent.agentType === 'online')[0];
			handleSelect(theOne?.paymentAgentID);
		}
		// eslint-disable-next-line
	}, [offlineVisible, paymentAgents]);
	console.log('usableMoney', usableMoney);
	return (
		<>
			<Modal isOpen={paymentModalOpen} onOpenChange={() => setPaymentModalOpen(false)} hideCloseButton scrollBehavior='inside'>
				<ModalContent>
					{(onClose) => (
						<>
							<ModalHeader className='flex flex-col gap-0 w-full text-center items-center justify-center'>
								<div className='w-[100px]  overflow-hidden'>
									<PayIllustration />
								</div>
								<div className='font-bold'>{getValue('app_v2_paymentAgents')}</div>
								<div className='font-light opacity-70 text-sm'>{getValue('app_v2_paymentAgents_desc')}</div>
							</ModalHeader>
							<ModalBody className='px-0 flex lfex-col gap-2 items-center justify-center w-full'>
								<AgentParams agent={paymentAgents?.find((a) => +a.paymentAgentID === +selectedID)} />
								<div className='flex flex-col w-full gap-2 max-h-[400px] overflow-y-scroll overflow-x-hidden px-2 py-2'>
									{offlineVisible && (
										<Card fullWidth isPressable className={`${paymentType === 'Offline' ? 'bg-primary text-primary-foreground' : 'bg-background'} border border-border shrink-0`} onPress={() => handleSelect('offline')}>
											<CardBody className='flex flex-row gap-2 items-center'>
												<Banknote className='w-6 h-6' />
												{getValue(`app_v2_paymentTypes_Offline`)}
											</CardBody>
										</Card>
									)}
									{!getSV('anoLoginUUID') && (
										<>
											{usableMoney > 0 && (
												<Card fullWidth isPressable className='bg-background border border-border shrink-0' onPress={() => handleSelect('vipMoney')}>
													<CardBody className='flex flex-row gap-2 items-center'>
														<Gem className='w-6 h-6' />
														{getValue(`app_v2_paymentTypes_vipMoney`)}
													</CardBody>
												</Card>
											)}
											{paymentAgents
												?.filter((agent) => agent.agentType === 'online')
												.map((agent) => (
													<Card fullWidth isPressable shadow='sm' className={`${+agent.paymentAgentID === +selectedID ? 'bg-primary text-primary-foreground' : 'bg-background '} border border-border shrink-0`} key={'' + agent.paymentAgentID} onPress={() => handleSelect(agent.paymentAgentID)}>
														<CardBody className='w-full flex flex-row gap-2 items-center'>
															<WalletCards className='w-6 h-6' />

															<Agents agent={agent} selected={+agent.paymentAgentID === +selectedID} />
														</CardBody>
													</Card>
												))}
										</>
									)}
								</div>
								{!offlineVisible && paymentAgents?.filter((agent) => agent.agentType === 'online').length === 0 && (
									<div className='payment-agent-container'>
										<div className='payment-agent-name'>{getValue(`app_v2_noPaymentAgents`)}</div>
									</div>
								)}
							</ModalBody>
							<ModalFooter className='w-full flex flex-row gap-2'>
								<BarSoftButton color='default' variant='light' onPress={onClose} fullWidth={false}>
									{getValue('app_v2_select_payment_agent_close')}
								</BarSoftButton>
								<BarSoftButton color='primary' onPress={onClose} fullWidth>
									{getValue('app_v2_select_payment_agent_done')}
								</BarSoftButton>
							</ModalFooter>
						</>
					)}
				</ModalContent>
			</Modal>
			<div className='flex w-full flex-col gap-2'>
				<div className='text-xs opacity-70'>{getValue('app_v2_basket_payment_agent')}</div>
				<Card isPressable onPress={() => setPaymentModalOpen(true)}>
					<CardBody className='w-full flex flex-row gap-2 items-center justify-between'>
						<div className='flex flex-row gap-2 items-center'>
							<div className='w-6 h-6'>
								<Icon name={paymentType !== 'Offline' ? 'bankCard' : 'cash'} className={paymentType !== 'Offline' ? 'fill-current' : 'stroke-current'} />
							</div>
							<div>
								<p className='font-bold '>{selectedLocalAgentLabel || getValue('app_v2_select_payment_agent')}</p>
								<div className='text-xs opacity-70'>
									<FormattedNumber value={paymentsNeeded} />
									{getValue('app_v2_select_will_be_paid')}
								</div>
							</div>
						</div>
						<div className='w-6 h-6'>
							<Icon name='right' className='stroke-current' />
						</div>
					</CardBody>
				</Card>
			</div>
		</>
	);
}
